import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css';

import WOW from 'wowjs'; // 导入wowjs
Vue.use(WOW);

Vue.use(ElementUI);
Vue.prototype.$wow = WOW;

Vue.directive('document-click',{
  bind(el,binding,vnode){
    document.addEventListener('click',binding.value,false);
  },
  inserted(){

  },
  updata(){

  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



